require.register("modules/m03/m03-activity/page-9b/page-9b", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page9b = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page9b;

  
});

